import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
@Component({
  selector: 'app-product-dialog',
  standalone: false,
  templateUrl: './product-dialog.component.html',
  styleUrl: './product-dialog.component.scss'
})
export class ProductDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ProductDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any // Inject the data passed from the RewardEditComponent
  ) {

  }

  ngOnInit(): void {
  }
  cancel(): void {
    this.dialogRef.close();
  }
  onTypeSelected(type: any): void {
    this.dialogRef.close({ type: type });

  }

}
